// extracted by mini-css-extract-plugin
export var editButton = "_ns-0";